import { DeactivateUserDialog } from "../DeactivateUserDialog";
import { ReactivateUserDialog } from "../ReactivateUserDialog";
import { ChangeRoleDialog } from "../ChangeRoleDialog";
import { DeleteUserDialog } from "../DeleteUserDialog";
import { SendNotificationDialog } from "../SendNotificationDialog";
import { TestAccountDialog } from "../TestAccountDialog";
import type { AdminNotificationResult } from "../notification-types";
import type { UserDetail } from "../types";
import type { UserDetailDialog, UserDetailDialogsOpen } from "./use-user-detail-dialogs";

interface UserDetailDialogsProps {
  readonly user: UserDetail;
  readonly currentAdminFirebaseUid: string | null;
  readonly open: UserDetailDialogsOpen;
  readonly onOpenChange: (dialog: UserDetailDialog, next: boolean) => void;
  /** Receives the i18n key of the success toast to show. */
  readonly onMutationSuccess: (key: string) => void;
  readonly onDeleted: () => void;
  readonly onNotificationSent: (result: AdminNotificationResult) => void;
}

/** The six dialogs of the user detail page, mounted once and driven by the page's open flags. */
export function UserDetailDialogs({
  user,
  currentAdminFirebaseUid,
  open,
  onOpenChange,
  onMutationSuccess,
  onDeleted,
  onNotificationSent,
}: UserDetailDialogsProps) {
  return (
    <>
      <DeactivateUserDialog
        user={user}
        currentAdminFirebaseUid={currentAdminFirebaseUid}
        open={open.deactivate}
        onOpenChange={(next) => onOpenChange("deactivate", next)}
        onSuccess={() => onMutationSuccess("users.deactivate.success")}
      />
      <ReactivateUserDialog
        user={user}
        open={open.reactivate}
        onOpenChange={(next) => onOpenChange("reactivate", next)}
        onSuccess={() => onMutationSuccess("users.reactivate.success")}
      />
      <ChangeRoleDialog
        user={user}
        currentAdminFirebaseUid={currentAdminFirebaseUid}
        open={open.changeRole}
        onOpenChange={(next) => onOpenChange("changeRole", next)}
        onSuccess={() => onMutationSuccess("users.changeRole.success")}
      />
      <DeleteUserDialog
        user={user}
        currentAdminFirebaseUid={currentAdminFirebaseUid}
        open={open.delete}
        onOpenChange={(next) => onOpenChange("delete", next)}
        onDeleted={onDeleted}
      />
      <SendNotificationDialog
        user={user}
        open={open.notify}
        onOpenChange={(next) => onOpenChange("notify", next)}
        onSent={onNotificationSent}
      />
      <TestAccountDialog
        user={user}
        open={open.testAccount}
        onOpenChange={(next) => onOpenChange("testAccount", next)}
        onSuccess={(next) =>
          onMutationSuccess(
            next ? "users.testAccount.successEnable" : "users.testAccount.successDisable",
          )
        }
      />
    </>
  );
}
